/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_Tonnes_100_HintInputs */

const en_us2_achievement_tonnes_100_hint = /** @type {(inputs: Achievement_Tonnes_100_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 t lifted in total`)
};

const pt_br2_achievement_tonnes_100_hint = /** @type {(inputs: Achievement_Tonnes_100_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 t levantadas no total`)
};

const es_419_achievement_tonnes_100_hint = /** @type {(inputs: Achievement_Tonnes_100_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 t levantadas en total`)
};

const pt_pt2_achievement_tonnes_100_hint = /** @type {(inputs: Achievement_Tonnes_100_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 t levantadas no total`)
};

const fr_fr2_achievement_tonnes_100_hint = /** @type {(inputs: Achievement_Tonnes_100_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 t soulevées au total`)
};

const de_de2_achievement_tonnes_100_hint = /** @type {(inputs: Achievement_Tonnes_100_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 t insgesamt bewegt`)
};

const it_it2_achievement_tonnes_100_hint = /** @type {(inputs: Achievement_Tonnes_100_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 t sollevate in totale`)
};

/**
* | output |
* | --- |
* | "100 t lifted in total" |
*
* @param {Achievement_Tonnes_100_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_tonnes_100_hint = /** @type {((inputs?: Achievement_Tonnes_100_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_Tonnes_100_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_tonnes_100_hint(inputs)
	if (locale === "es-419") return es_419_achievement_tonnes_100_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_tonnes_100_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_tonnes_100_hint(inputs)
	if (locale === "de-DE") return de_de2_achievement_tonnes_100_hint(inputs)
	if (locale === "it-IT") return it_it2_achievement_tonnes_100_hint(inputs)
	return en_us2_achievement_tonnes_100_hint(inputs)
});
export { achievement_tonnes_100_hint as "achievement.tonnes_100_hint" }